import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Moment from "react-moment";
import {Link} from "react-router-dom";
import Pager from "../../../controls/Pager";
import ActionLink from "../../../controls/ActionLink";

const $ = window.jQuery;

class TenderRequestResults extends Component {
    static propTypes = {
        results: PropTypes.object.isRequired,
        pageSize: PropTypes.number.isRequired,
        incomingPageIndex: PropTypes.number.isRequired,
        acceptedPageIndex: PropTypes.number.isRequired,
        underwayPageIndex: PropTypes.number.isRequired,
        archivedPageIndex: PropTypes.number.isRequired,
        onIncomingPageChanged: PropTypes.func.isRequired,
        onAcceptedPageChanged: PropTypes.func.isRequired,
        onUnderwayPageChanged: PropTypes.func.isRequired,
        onArchivedPageChanged: PropTypes.func.isRequired,
        tab: PropTypes.number.isRequired,
        onChangeTab: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        tab: this.props.tab
    };

    render() {
        const {results} = this.props;
        const {incomingPageIndex, acceptedPageIndex, underwayPageIndex, archivedPageIndex} = this.props;
        const {onIncomingPageChanged, onAcceptedPageChanged, onUnderwayPageChanged, onArchivedPageChanged} = this.props;
        const tendersList = tenders => {
            return tenders && tenders.length
                ? tenders.map(tender =>
                    <li key={tender.tenderRequestId} className="list-group-item">
                        {
                            tender.hasProblem &&
                            <span className="label label-danger pull-right">Проблема</span>
                        }
                        <Link to={`/tenders/${tender.tenderId}`}
                              className="widget-support-tickets-title">
                            <strong>№ {tender.tenderNumber}</strong>
                            {' '}
                            <small className="widget-support-tickets-id">
                                <Moment locale="ru" format="DD.MM.YYYY HH:mm">
                                    {tender.createdAt}
                                </Moment>
                            </small>
                        </Link>
                        {tender.items.map(item => {
                            let deliveryInfo = tender.deliveryDate
                                ? (
                                    <span>
                                        на <Moment>{tender.deliveryDate}</Moment> в {tender.deliveryAddress}
                                    </span>
                                )
                                : (
                                    <span>
                                        самовывозом из {tender.deliveryAddress}
                                    </span>
                                );

                            return (
                                <div key={0}>
                                    <span className="widget-support-tickets-info">
                                        {item.name} ({item.count} шт. {deliveryInfo})
                                    </span>
                                </div>
                            );
                        })}
                    </li>
                )
                : <p>Ничего не найдено</p>;
        };

        return (
            <div className="panel">
                <div className="panel-heading">
                    <span className="panel-title">
                        <strong>Заказы</strong>
                        {/*<small>6 результатов</small>*/}
                    </span>
                </div>
                <div className="panel-body">
                    <ul className="nav nav-tabs nav-tabs-simple">
                        <li className={this.state.tab === 1 ? 'active' : ''}>
                            <ActionLink
                               disabled={!results.incomingTenderRequestsCount}
                               onClick={() => this.changeTab(1)}>
                                Новые
                                {
                                    !!results.incomingTenderRequestsCount &&
                                    <span className="label label-info">{results.incomingTenderRequestsCount}</span>
                                }
                            </ActionLink>
                        </li>
                        <li className={this.state.tab === 2 ? 'active' : ''}>
                            <ActionLink
                               disabled={!results.myTenderRequestsCount}
                               onClick={() => this.changeTab(2)}>
                                Мои торги
                                {
                                    !!results.myTenderRequestsCount &&
                                    <span className="label label-info">{results.myTenderRequestsCount}</span>
                                }
                            </ActionLink>
                        </li>
                        <li className={this.state.tab === 3 ? 'active' : ''}>
                            <ActionLink
                               disabled={!results.underwayTenderRequestsCount}
                               onClick={() => this.changeTab(3)}>
                                В работе
                                {
                                    !!results.underwayTenderRequestsCount &&
                                    <span className="label label-info">{results.underwayTenderRequestsCount}</span>
                                }
                            </ActionLink>
                        </li>
                        <li className={this.state.tab === 4 ? 'active' : ''}>
                            <ActionLink
                               disabled={!results.archivedTenderRequestsCount}
                               onClick={() => this.changeTab(4)}>
                                Архив
                                {
                                    !!results.archivedTenderRequestsCount &&
                                    <span className="label label-info">{results.archivedTenderRequestsCount}</span>
                                }
                            </ActionLink>
                        </li>
                    </ul>
                    <div className="tab-content p-b-0">
                        <div className={`tab-pane ${this.state.tab === 1 ? 'active' : ''}`} id="incoming-tender-requests">
                            <div className="row">
                                <div className="col-md-12 pull-right">
                                    <div className="pull-right">
                                        <Pager className="m-y-1"
                                               pageSize={this.props.pageSize}
                                               pageIndex={incomingPageIndex}
                                               totalCount={results.incomingTenderRequestsCount}
                                               onChange={onIncomingPageChanged}/>
                                    </div>
                                </div>
                            </div>
                            <ul className="list-group m-b-0">
                                {tendersList(results.incomingTenderRequests)}
                            </ul>
                        </div>
                        <div className={`tab-pane ${this.state.tab === 2 ? 'active' : ''}`} id="accepted-tender-requests">
                            <div className="row">
                                <div className="col-md-12 pull-right">
                                    <div className="pull-right">
                                        <Pager className="m-y-1"
                                               pageSize={this.props.pageSize}
                                               pageIndex={acceptedPageIndex}
                                               totalCount={results.myTenderRequestsCount}
                                               onChange={onAcceptedPageChanged}/>
                                    </div>
                                </div>
                            </div>
                            <ul className="list-group m-b-0">
                                {tendersList(results.myTenderRequests)}
                            </ul>
                        </div>
                        <div className={`tab-pane ${this.state.tab === 3 ? 'active' : ''}`} id="underway-tender-requests">
                            <div className="row">
                                <div className="col-md-12 pull-right">
                                    <div className="pull-right">
                                        <Pager className="m-y-1"
                                               pageSize={this.props.pageSize}
                                               pageIndex={underwayPageIndex}
                                               totalCount={results.underwayTenderRequestsCount}
                                               onChange={onUnderwayPageChanged}/>
                                    </div>
                                </div>
                            </div>
                            <ul className="list-group m-b-0">
                                {tendersList(results.underwayTenderRequests)}
                            </ul>
                        </div>
                        <div className={`tab-pane ${this.state.tab === 4 ? 'active' : ''}`} id="archived-tender-requests">
                            <div className="row">
                                <div className="col-md-12 pull-right">
                                    <div className="pull-right">
                                        <Pager className="m-y-1"
                                               pageSize={this.props.pageSize}
                                               pageIndex={archivedPageIndex}
                                               totalCount={results.archivedTenderRequestsCount}
                                               onChange={onArchivedPageChanged}/>
                                    </div>
                                </div>
                            </div>
                            <ul className="list-group m-b-0">
                                {tendersList(results.archivedTenderRequests)}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    changeTab(tab) {
        this.setState({tab}, () => this.props.onChangeTab(tab));
    }
}

export default TenderRequestResults;


// WEBPACK FOOTER //
// ./src/pages/OmniSearch/Results/TenderRequestResults.js